import React from 'react';
import { RequestError } from '@ynomia/client';
import { modal } from '../antdProvider';

export const renderPercentage = (units: number, totalUnits: number): string => {
  if (totalUnits === 0) return '0';
  const percentageUnits = ((units * 100) / totalUnits);
  if (percentageUnits === 0) return '0';
  if (percentageUnits < 1) return '<1';
  if (percentageUnits > 99 && percentageUnits < 100) return '>99';
  return `${Math.round(percentageUnits)}`;
};

export const planUploadCompleteModal = () => modal.info({
  title: 'Upload Plan Generated',
  content: (
    <p>
      Please review all Errors, Warnings, Info and Changes
      before you Apply the Update.
      Once reviewed, if changes
      are required, please make those changes in your CSV
      and re-upload the new file.
    </p>
  ),
});

export const planUploadFailedModal = (err: RequestError) => {
  const { status, body } = err;
  modal.error({
    title: 'Issue Detected',
    content: (
      <>
        <p>{`${body?.msg || ''}`}</p>
        <p>{`Code: ${status}`}</p>
      </>
    ),
    onOk() { },
  });
};

export const applyUploadCompleteModal = () => modal.success({
  title: 'Apply Complete!',
  content: (
    <p>
      The apply had been successful!
    </p>
  ),
  onOk() { },
});
